export default __webpack_public_path__ + "static/media/standsExpo_caname.656a600f.jpg";